<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>
  {{ data.prompt }}
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton mat-dialog-close cdkFocusInitial>{{ 'generic.no' | translate }}</button>
  <button matButton [mat-dialog-close]="true" class="red-button">{{ 'generic.yes' | translate }}</button>
</mat-dialog-actions>
